/**
 * InvoicesCard — Dashboard card replacing CashflowCard.
 *
 * Quick task 260512-uat-batch (F-06, 2026-05-12) — CashflowCard relied on
 * an unbuilt Cashflow report and rendered "—" placeholders. Petra: drop
 * it and use Invoices instead — Invoicing Status report exists today.
 *
 * Lightweight CTA card: title + short description + link to the
 * `/reports/invoicing-status` page (admin-gated route). Data fetching is
 * intentionally minimal — the underlying report owns the full breakdown.
 */
import { Link } from 'react-router-dom';
import { Card } from '../ui/Card';
import { Btn } from '../ui/Btn';

export function InvoicesCard() {
  return (
    <Card title="Invoices">
      <p className="text-[12px] text-ms-text-muted mb-3">
        Track invoicing status across all customers.
      </p>
      <Link to="/reports/invoicing-status">
        <Btn variant="secondary" size="sm" className="w-full">
          View invoicing report
        </Btn>
      </Link>
    </Card>
  );
}
